import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { MyHeader } from '../config/myHeader';
import { GenericToastrService } from '../generic-components/generic-toastr/generic-toastr.service';

@Injectable({
  providedIn: 'any'
})
export class LoginService {

loginRefreshTokenDate: Date = new Date()
lastTokenDate: Date = new Date();
tokenHeader: MyHeader=new MyHeader();

  constructor(private http: HttpClient, private router: Router, private toastr: GenericToastrService) { }

  public getToken(username: string, password: string): any{
    const body: HttpParams= new HttpParams()
    .set("client_id",environment.clientId)
    .set("client_secret",environment.clientSecret)
    .set("username",username)
    .set("password",password)
    .set("grant_type", environment.grantType);
    let header = this.tokenHeader.tokenHeader();

    localStorage.setItem("username", username);

    return this.http.post(environment.urlKeycloakAccesToken, body.toString(),
    {
      headers: header
    },
    );
  }


  public getNewToken(){
    this.lastTokenDate = new Date();
    const body: HttpParams= new HttpParams()
    .set("client_id", environment.clientId)
    .set("client_secret", environment.clientSecret)
    .set("grant_type", "refresh_token")
    .set("refresh_token",JSON.parse(localStorage.getItem('token') ?? '""').refresh_token)
    return this.http.post(environment.urlKeycloakAccesToken, body.toString(),
    {
      headers: this.tokenHeader.tokenHeader()
    }
    );
  }

  public isAlreadyAuthentificated() {
    this.getNewToken().subscribe({
      next: (res) => {
        localStorage.setItem('token', JSON.stringify(res));
        if (['/login', '/'].includes(window.location.pathname)) {
          this.router.navigateByUrl('/accueil');
        }
      },
      error: () => {
        localStorage.clear(); 
        this.router.navigateByUrl('');
        this.toastr.openSnackBarProblem("Session expirée !");
      }
    });
  }
}
